// import vannila from '../assets/vannila.png';
// import biocakestext from '../assets/biocakestext.png';
// import biocakestext from '../assets/biocakestext.png';
// import biocakestext from '../assets/biocakestext.png';
// import biocakestext from '../assets/biocakestext.png';

export const food = [
  {
    id: 1,
    name: 'Vannila truffle cake',
    category: 'vannila',
    image:
      'https://cakeimages.netlify.app/42.jpg',
      // price: '30.98',
  },
  {
    id: 2,
    name: 'Blueberry cake',
    category: 'blueberry',
    image:
      'https://cakeimages.netlify.app/46.jpg',
    // price: '30.7',
  },
  {
    id: 3,
    name: 'Rainbow cake',
    category: 'vannila',
    image:
      'https://cakeimages.netlify.app/16.jpg',
    // price: '40.08',
  },
  {
    id: 4,
    name: 'Dark chocolate ganache cake',
    category: 'chocolate truffle',
    image:
      'https://cakeimages.netlify.app/47.jpg',
    // price: '50.99',
  },
  {
    id: 5,
    name: 'Barbie doll cake',
    category: 'strawberry',
    image:
      'https://cakeimages.netlify.app/18.jpg',
    // price: '24.90',
  },
  {
    id: 6,
    name: 'Pista cake',
    category: 'pista',
    image:
      'https://cakeimages.netlify.app/33.jpg',
    // price: '39.99',
  },
  {
    id: 7,
    name: 'Chocolate truffle cake',
    category: 'chocolate truffle',
    image:
      'https://cakeimages.netlify.app/40.jpg',
    // price: '40',
  },
  {
    id: 8,
    name: 'Black forest cake',
    category: 'black forest',
    image:
      'https://cakeimages.netlify.app/23.jpg',
    // price: '29.90'
  },
  {
    id: 9,
    name: 'Butter scotch cake',
    category: 'pista',
    image:
      'https://cakeimages.netlify.app/43.jpg',
    // price: '34.09'
  },
  {
    id: 10,
    name: 'Pineapple cake',
    category: 'pineapple',
    image:
      'https://cakeimages.netlify.app/37.jpg',
    // price: '45.70'
  },
  {
    id: 11,
    name: 'Gulab jamun cake',
    category: 'pista',
    image:
      'https://cakeimages.netlify.app/17.jpg',
    // price: '49.99'
  },
  {
    id: 12,
    name: 'Black forest cake',
    category: 'black forest',
    image:
      'https://cakeimages.netlify.app/38.jpg',
    // price: '29.90'
  },
  {
    id: 13,
    name: 'Be chocoholic',
    category: 'pineapple',
    image:
      'https://cakeimages.netlify.app/34.jpg',
    // price: '34.09'
  },
  {
    id: 14,
    name: 'chocolate truffle',
    category: 'chocolate truffle',
    image:
      'https://cakeimages.netlify.app/50.jpg',
    // price: '49.99'
  },
  {
    id: 15,
    name: 'Pineapple Cake',
    category: 'pineapple',
    image:
      'https://cakeimages.netlify.app/10.jpg',
    // price: '29.90'
  },
  {
    id: 16,
    name: 'Blueberry cake',
    category: 'buleberry',
    image:
      'https://cakeimages.netlify.app/1.jpg',
    // price: '45.70'
  },
  {
    id: 17,
    name: 'Blueberry cake',
    category: 'blueberry',
    image:
      'https://cakeimages.netlify.app/2.jpg',
    // price: '45.70'
  },
  
  {
    id: 18,
    name: 'Red velvet cake',
    category: 'black forest',
    image:
      'https://cakeimages.netlify.app/4.jpg',
    // price: '45.70'
  },
  {
    id: 19,
    name: 'Chocolate cake',
    category: 'chocolate',
    image:
      'https://cakeimages.netlify.app/14.jpg',
    // price: '45.70'
  },
  {
    id: 20,
    name: 'Black forest cake',
    category: 'black forest',
    image:
      'https://cakeimages.netlify.app/24.jpg',
    // price: '45.70'
  },
  {
    id: 21,
    name: 'Choco truffle',
    category: 'chocolate truffle',
    image:
      'https://cakeimages.netlify.app/22.jpg',
    // price: '45.70'
  },
  {
    id: 22,
    name: 'Vanilla cake',
    category: 'vanilla',
    image:
      'https://cakeimages.netlify.app/7.jpg',
    // price: '45.70'
  },
  {
    id: 23,
    name: 'Blueberry cake',
    category: 'blueberry',
    image:
      'https://cakeimages.netlify.app/29.jpg',
    // price: '45.70'
  },
  
  {
    id: 24,
    name: 'chocoholic',
    category: 'chocolate',
    image:
      'https://cakeimages.netlify.app/3.jpg',
    // price: '45.70'
  },
  {
    id: 25,
    name: 'gulab jamun',
    category: 'chocolate',
    image:
      'https://cakeimages.netlify.app/5.jpg',
    // price: '45.70'
  },
  {
    id: 26,
    name: 'chocolate cake',
    category: 'chocolate',
    image:
      'https://cakeimages.netlify.app/27.jpg',
    // price: '45.70'
  },
  {
    id: 27,
    name: 'Vannila milk cake',
    category: 'vannila',
    image:
      'https://cakeimages.netlify.app/35.jpg',
    // price: '45.70'
  },
  {
    id: 28,
    name: 'Blueberry cake',
    category: 'blueberry',
    image:
      'https://cakeimages.netlify.app/30.jpg',
    // price: '45.70'
  },
  {
    id: 29,
    name: 'Strawberry cake',
    category: 'strawberry',
    image:
      'https://cakeimages.netlify.app/36.jpg',
    // price: '45.70'
  },
  {
    id: 30,
    name: 'Whiteforest cake',
    category: 'whiteforest',
    image:
      'https://cakeimages.netlify.app/48.jpg',
    // price: '45.70'
  },
  {
    id: 31,
    name: 'Ferrero Rocher cake',
    category: 'chocolate',
    image:
      'https://cakeimages.netlify.app/13.jpg',
    // price: '45.70'
  },
  {
    id: 32,
    name: 'Nutty bubble cake',
    category: 'vannila',
    image:
      'https://cakeimages.netlify.app/6.jpg',
    // price: '45.70'
  },
  {
    id: 33,
    name: 'White forest cake',
    category: 'white forest',
    image:
      'https://cakeimages.netlify.app/8.jpg',
    // price: '45.70'
  },
  {
    id: 34,
    name: 'Black forest cake',
    category: 'black forest',
    image:
      'https://cakeimages.netlify.app/9.jpg',
    // price: '45.70'
  },
  {
    id: 35,
    name: 'Gel cake',
    category: 'vannila',
    image:
      'https://cakeimages.netlify.app/11.jpg',
    // price: '45.70'
  },
  {
    id: 36,
    name: 'Gel cake',
    category: 'vannila',
    image:
      'https://cakeimages.netlify.app/12.jpg',
    // price: '45.70'
  },
  {
    id: 37,
    name: 'Vanilla cake',
    category: 'vannila',
    image:
      'https://cakeimages.netlify.app/15.jpg',
    // price: '45.70'
  },
  {
    id: 38,
    name: 'Blueberry cake',
    category: 'blueberry',
    image:
      'https://cakeimages.netlify.app/19.jpg',
    // price: '45.70'
  },
  {
    id: 39,
    name: 'Dark choco cake',
    category: 'chocolate',
    image:
      'https://cakeimages.netlify.app/20.jpg',
    // price: '45.70'
  },
  {
    id: 40,
    name: 'Black forest cake',
    category: 'black forest',
    image:
      'https://cakeimages.netlify.app/21.jpg',
    // price: '45.70'
  },
  {
    id: 41,
    name: 'Customized Vanilla cake',
    category: 'vanilla',
    image:
      'https://cakeimages.netlify.app/25.jpg',
    // price: '45.70'
  },
  {
    id: 42,
    name: 'Chocolate truffle cake',
    category: 'chocolate truffle',
    image:
      'https://cakeimages.netlify.app/26.jpg',
    // price: '45.70'
  },
  {
    id: 43,
    name: 'Choco truffle cake',
    category: 'chocolate truffle',
    image:
      'https://cakeimages.netlify.app/31.jpg',
    // price: '45.70'
  },
  {
    id: 44,
    name: 'Black forest cake',
    category: 'black forest',
    image:
      'https://cakeimages.netlify.app/32.jpg',
    // price: '45.70'
  },
  {
    id: 45,
    name: 'Choco chips cake',
    category: 'chocolate',
    image:
      'https://cakeimages.netlify.app/41.jpg',
    // price: '45.70'
  },
  {
    id: 46,
    name: 'Choco nuts cake',
    category: 'chocolate',
    image:
      'https://cakeimages.netlify.app/28.jpg',
    // price: '45.70'
  },
  {
    id: 47,
    name: 'Choco truffle',
    category: 'chocolate truffle',
    image:
      'https://cakeimages.netlify.app/39.jpg',
    // price: '45.70'
  },
  {
    id: 48,
    name: 'Pineapple cake',
    category: 'pineapple',
    image:
      'https://cakeimages.netlify.app/44.jpg',
    // price: '45.70'
  },
  {
    id: 49,
    name: 'Vannila milk cake',
    category: 'vannila',
    image:
      'https://cakeimages.netlify.app/45.jpg',
    // price: '45.70'
  },
  {
    id: 50,
    name: 'Whiteforest cake',
    category: 'white forest',
    image:
      'https://cakeimages.netlify.app/49.jpg',
    // price: '45.70'
  },
  {
    id: 51,
    name: 'Chocolate truffle',
    category: 'chocolate truffle',
    image:
      'https://cakeimages.netlify.app/51.jpg',
    // price: '45.70'
  },
  {
    id: 52,
    name: 'Chocolaty Brownies',
    category: 'double chocolate brownies',
    image:
      'https://cakeimages.netlify.app/52.jpg',
    // price: '45.70'
  },
  // {
  //   id: 53,
  //   name: 'Chocolaty Brownies',
  //   category: 'double chocolate brownies',
  //   image:
  //     'https://cakeimages.netlify.app/53.jpg',
  //   // price: '45.70'
  // },

  
];

export const categories = [
  {
    id: 1,
    name: 'Vannila',
    image:'https://cakeimages.netlify.app/c2.png',    },
  {
    id: 2,
    name: 'Chocolate',
    image:
      'https://static.vecteezy.com/system/resources/previews/013/453/751/non_2x/pastry-cake-3d-rendering-isometric-icon-png.png',
  },
  {
    id: 3,
    name: 'Blueberry',
    image:
      'https://cakeimages.netlify.app/c5.png',
  },
  {
    id: 4,
    name: 'Pista',
    image:
      'https://cakeimages.netlify.app/c3.png',    
  },
  {
    id: 5,
    name: 'Pineapple',
    image:
      'https://cakeimages.netlify.app/c1.png',
  },
  {
    id: 6,
    name: 'Strawberry',
    image:
      'https://cakeimages.netlify.app/c4.png',
  },
  {
    id: 7,
    name: 'Black forest',
    image:
      'https://cakeimages.netlify.app/c6.png',
  },
  {
    id: 8,
    name: 'White forest',
    image:
      'https://cakeimages.netlify.app/c7.png',
  },
  {
    id: 9,
    name: 'Chocolate truffle',
    image:
      'https://cakeimages.netlify.app/c8.png',
  },
  {
    id: 10,
    name: 'Butterscotch',
    image:
      'https://cakeimages.netlify.app/c9.png',
  },
  // {
  //   id: 11,
  //   name: 'New year',
  //   image:
  //     '',
  // },
  // {
  //   id: 12,
  //   name: 'Christmas',
  //   image:
  //     '',
  // },
  {
    id: 13,
    name: 'Double chocolate brownies',
    image:
      'https://cakeimages.netlify.app/c10.png',
  },
];
